module.exports = __webpack_public_path__ + "static/img/red-bull-logo.0d4510c4.png";